import { TablePagination } from "@mui/material";
import { perPagePaginationArray } from "interfaces/FilterTypes";
import { updateFilter } from "store/slices/tableSlice";
import { useAppDispatch, useAppSelector } from "store/store";

interface CommonPaginationProps {
  totalCount: number;
  name?: string;
}

const CommonPagination: React.FC<CommonPaginationProps> = (props) => {
  const { totalCount, name } = props;

  const dispatch = useAppDispatch();

  const commonFilter = useAppSelector((state) => state?.table?.commonFilter);

  const handlePageChange = (
    _event: React.MouseEvent<HTMLButtonElement> | null,
    newPage: number,
  ) => {
    dispatch(
      updateFilter({
        name,
        filter: {
          page: newPage,
          skip: newPage * commonFilter[name]?.take,
        },
      }),
    );
  };

  const handleRowsPerPageChange = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    dispatch(
      updateFilter({
        name,
        filter: {
          skip: 0,
          page: 0,
          take: event.target.value,
        },
      }),
    );
  };

  return (
    <TablePagination
      style={{ flex: "none" }}
      component="div"
      labelRowsPerPage="Rows"
      tabIndex={-1}
      count={totalCount}
      page={commonFilter[name]?.page}
      rowsPerPage={commonFilter[name]?.take}
      onPageChange={handlePageChange}
      onRowsPerPageChange={handleRowsPerPageChange}
      rowsPerPageOptions={
        totalCount > perPagePaginationArray[0] ? perPagePaginationArray : []
      }
      labelDisplayedRows={({ from, to, count }) => {
        const newForm =
          from > count ? totalCount - commonFilter[name].take + 1 : from;
        return `${newForm}–${to} of ${
          count !== -1 ? count : `more than ${to}`
        }`;
      }}
    />
  );
};

export default CommonPagination;
